<template>
  <!-- 资产概览 -->
  <div class="section">
    <dna-wrapper>
      <div class="user">
        <div class="info">
          <span @click="gotoAddress" class="img" v-if="!img">{{
            address.substr(0, 2)
          }}</span>
          <img @click="gotoAddress" class="img" alt src v-if="img" />
          <span class="welcome">{{ $t("assetSummary.welcome") }}</span>
          <span class="address">{{ address }}</span>
        </div>
        <div class="logo">
          <!-- <img class="logo" src="../../assets/logos/dna-2.png" /> -->
        </div>
      </div>
      <div class="items">
        <!-- 总余额 -->
        <div class="info">
          <div>{{ $t("assetSummary.totalTitle") }}</div>
          <div>
            {{
              formatTokenWithoutSymbol(
                BigNumber(availableBalance)
                  .plus(vestingBalance)
                  .toString()
              )
            }}
          </div>
          <!-- <div>≈ {{totalAmount}}</div> -->
        </div>
        <!-- 可用余额 -->
        <div class="info">
          <div>{{ $t("assetSummary.availableTitle") }}</div>
          <div>{{ formatTokenWithoutSymbol(availableBalance) }}</div>
        </div>
        <!-- 冻结余额 -->
        <div class="info">
          <div>{{ $t("assetSummary.frozenTitle") }}</div>
          <div>{{ formatTokenWithoutSymbol(vestingBalance) }}</div>
        </div>
      </div>
    </dna-wrapper>
    <dna-spin v-if="isLoading" class="full-spin"></dna-spin>
  </div>
</template>

<script>
import wsSubscribe from "@/req/wsSubscribe.js";
import req from "@/req/req.js";
import UTIL from "@/util/util.js";
import DATA from "@/data/data.js";
import BigNumber from "bignumber.js";

let fetchTokenTimeout = 0;
export default {
  data() {
    return {
      img: "",
      isLoading: true,
      BigNumber
    };
  },
  async mounted() {
    let that = this;
    await that.load();
  },
  computed: {
    address() {
      return (
        this.$store.state.userInfo.name || this.$store.state.userInfo.address
      );
    },
    availableBalance() {
      let balances = this.$store.state.userInfo.balances || [];
      balances = balances.filter(it => it);
      let coreAsset = balances.find(
        it => it.asset_type == DATA.DLP_TOKEN_ASSET_ID
      );
      //console.log("coreAsset:" + JSON.stringify(coreAsset));
      if (coreAsset) {
        this.isLoading = false;
        return coreAsset.balance;
      } else {
        return 0;
      }
    },
    vestingBalance() {
      let vesting_balances = this.$store.state.userInfo.vesting_balances || [];
      let balance = new BigNumber(0);
      for (let i = 0; i < vesting_balances.length; i++) {
        if (vesting_balances[i].balance.asset_id == DATA.DLP_TOKEN_ASSET_ID) {
          balance = balance.plus(vesting_balances[i].balance.amount);
        }
      }
      return balance.toString();
    },
    totalAmount() {
      let totalAmount = this.$store.state.userInfo.totalAmount || {};
      totalAmount = JSON.parse(JSON.stringify(totalAmount));
      let currencySymbol = this.$i18n.t("global.currencySymbol");
      currencySymbol = currencySymbol || "$";
      if (
        totalAmount &&
        totalAmount.hasOwnProperty(currencySymbol) &&
        totalAmount[currencySymbol]
      ) {
        return currencySymbol + " " + totalAmount[currencySymbol];
      }
      return "-";
    }
  },
  methods: {
    async load() {
      let that = this;
      if (!that.address) {
        that.$router.push("/").catch(err => {});
        return;
      }
      this.isLoading = false;
    },
    gotoAddress() {
      let that = this;
      if (that.address) {
        that.$router
          .push({
            path: "/accountDetails",
            query: {
              account: that.address
            }
          })
          .catch(err => {});
        return;
      }
    },
    formatNumeral(val) {
      return UTIL.formatNumeral(val, this.$i18n.t("numeral.symbols"));
    },
    formatTokenWithoutSymbol(val) {
      return UTIL.formatToken(val, [], 4, ""); //this.$i18n.t("numeral.symbols")
    }
  }
};
</script>

<style lang="less" scoped>
@import url("./AssetSummary.less");
</style>